module.exports = __webpack_public_path__ + "img/s5.83b10c3.png";